import { useEffect } from 'react';

/**
 * Custom hook that scrolls the window to the top when the component mounts.
 * Useful for pages that should always start at the top when navigated to.
 */
const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

export default useScrollToTop;
